export const FAQ_ITEMS = [
  {
    question: 'Is this QR code generator free?',
    answer:
      'Yes. PixelUtility QR is completely free to use. There is no sign-up, no credit card, and no hidden paywall for basic downloads.',
  },
  {
    question: 'Do QR codes expire?',
    answer:
      'Static QR codes generated here do not expire on their own. They remain valid as long as the encoded content (URL, text, etc.) remains valid and accessible.',
  },
  {
    question: 'Are there redirects?',
    answer:
      'No. Your QR code points directly to the content you enter. We do not insert tracking redirect pages between the scan and your destination.',
  },
  {
    question: 'Can I create a WiFi QR code?',
    answer:
      'Yes. Select the Wi-Fi tab, enter your network name (SSID), password, and encryption type. Guests can scan to connect without typing the password manually.',
  },
  {
    question: 'Can I generate a vCard or contact QR code?',
    answer:
      'Yes. Use the V-card option to encode name, phone, email, company, and website into a scannable contact card for business cards and events.',
  },
  {
    question: 'Can I use generated QR codes commercially?',
    answer:
      'Yes. You may use QR codes created with this tool for personal and commercial projects, including marketing, packaging, and print materials.',
  },
  {
    question: 'Can I download SVG?',
    answer:
      'Yes. Use the Download SVG button for a scalable vector file ideal for print, design tools, and high-resolution output. PNG is recommended when using a decorative frame.',
  },
  {
    question: 'Is my data stored on a server?',
    answer:
      'QR generation runs in your browser. We do not require an account and do not store the content you encode for the purpose of generating your code.',
  },
];

export const HOW_TO_STEPS = [
  {
    name: 'Enter your content',
    text: 'Choose URL, text, email, call, SMS, vCard, or Wi-Fi and fill in the fields.',
  },
  {
    name: 'Customize your QR code',
    text: 'Adjust dot style, colors, optional frame, and center logo in the Design step.',
  },
  {
    name: 'Download instantly',
    text: 'Export a high-resolution PNG or SVG file ready for print or digital use.',
  },
];
